<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="black" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6663 10C16.6663 6.3181 13.6816 3.33333 9.99967 3.33333C6.31778 3.33333 3.33301 6.3181 3.33301 10C3.33301 13.6819 6.31778 16.6667 9.99967 16.6667C13.6816 16.6667 16.6663 13.6819 16.6663 10ZM11.3741 7.77777L9.99961 9.15231L8.6252 7.77777L7.77745 8.62552L9.15199 9.99993L7.77745 11.3745L8.6252 12.2222L9.99961 10.8476L11.3741 12.2222L12.2219 11.3745L10.8472 9.99993L12.2219 8.62552L11.3741 7.77777Z"
    />
  </svg>
</template>
